/* ==========================================================================
   BeBroot: Instagram reels (sections/bb-reels.liquid)
   1. Card clips are muted and always will be: autoplay policy refuses sound
      without a gesture. Sound lives in one shared popup player that opens
      from a real tap, so it may unmute and show native controls.
   2. Only cards actually on screen play; several 9:16 clips decoding at once
      makes a mid-range phone stutter.
   ========================================================================== */
(function () {
	if (window.bbReelsLoaded) return;
	window.bbReelsLoaded = true;

	var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	var IG_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true" focusable="false"><rect x="3" y="3" width="18" height="18" rx="5.2"/><circle cx="12" cy="12" r="4"/><circle cx="17.3" cy="6.7" r="1.1" fill="currentColor" stroke="none"/></svg>';
	var X_SVG = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg>';

	function chevron(dir) {
		var d = dir === 'prev' ? 'M15 5 8 12l7 7' : 'M9 5l7 7-7 7';
		return '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="' + d + '"/></svg>';
	}

	function quietPlay(v) {
		var p = v.play();
		if (p && p.catch) p.catch(function () {});
	}

	// Every card clip on the page with its on-screen state; the popup pauses them all and hands back on close.
	var cardVideos = [];

	function pauseCards() {
		cardVideos.forEach(function (rec) { rec.el.pause(); });
	}

	function resumeVisibleCards() {
		if (reduceMotion) return;
		cardVideos.forEach(function (rec) { if (rec.visible) quietPlay(rec.el); });
	}

	var player = (function () {
		var el = null;
		var group = [];
		var index = 0;
		var lastFocus = null;

		function isOpen() { return !!el && !el.hidden; }
		function frame() { return el.querySelector('.bb-lb__frame'); }

		function teardown() {
			var v = frame().querySelector('video');
			if (v) {
				v.pause();
				// drop the source and reload, or Chrome keeps downloading the clip after close
				v.removeAttribute('src');
				v.load();
			}
			frame().innerHTML = '';
		}

		function render() {
			var card = group[index];
			if (!card) return;
			teardown();

			var v = document.createElement('video');
			v.className = 'bb-lb__player';
			v.controls = true;
			v.loop = true;
			v.playsInline = true;
			v.setAttribute('playsinline', '');
			v.preload = 'auto';
			var poster = card.getAttribute('data-reel-poster');
			if (poster) v.poster = poster;
			v.src = card.getAttribute('data-reel-src');
			frame().appendChild(v);

			// still inside the tap's gesture, so sound is allowed; if a hardened browser says no, play muted with controls visible
			v.muted = false;
			var p = v.play();
			if (p && p.catch) p.catch(function () { v.muted = true; quietPlay(v); });

			el.querySelector('.bb-lb__caption').textContent = card.getAttribute('data-reel-caption') || '';

			var insta = card.getAttribute('data-reel-insta') || '';
			var instaEl = el.querySelector('.bb-lb__insta');
			instaEl.hidden = !insta;
			if (insta) instaEl.href = insta;

			var shop = card.getAttribute('data-reel-shop') || '';
			var shopEl = el.querySelector('.bb-lb__shop');
			shopEl.hidden = !shop;
			if (shop) {
				shopEl.href = shop;
				shopEl.textContent = card.getAttribute('data-reel-shop-label') || 'Shop this';
			}

			var many = group.length > 1;
			el.querySelector('.bb-lb__nav--prev').hidden = !many;
			el.querySelector('.bb-lb__nav--next').hidden = !many;
		}

		function trapTab(e) {
			var focusable = Array.prototype.slice.call(el.querySelectorAll('button:not([hidden]), a[href]:not([hidden]), video'))
				.filter(function (n) { return n.offsetParent !== null; });
			if (!focusable.length) return;
			var first = focusable[0];
			var last = focusable[focusable.length - 1];
			if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
			else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
		}

		function build() {
			if (el) return;
			el = document.createElement('div');
			el.className = 'bb-lb';
			el.setAttribute('role', 'dialog');
			el.setAttribute('aria-modal', 'true');
			el.setAttribute('aria-label', 'Video player');
			el.hidden = true;
			el.innerHTML =
				'<div class="bb-lb__backdrop" data-lb-close></div>' +
				'<button class="bb-lb__close" type="button" data-lb-close aria-label="Close video">' + X_SVG + '</button>' +
				'<div class="bb-lb__stage">' +
					'<div class="bb-lb__row">' +
						'<button class="bb-lb__nav bb-lb__nav--prev" type="button" data-lb-step="-1" aria-label="Previous video">' + chevron('prev') + '</button>' +
						'<div class="bb-lb__frame"></div>' +
						'<button class="bb-lb__nav bb-lb__nav--next" type="button" data-lb-step="1" aria-label="Next video">' + chevron('next') + '</button>' +
					'</div>' +
					'<div class="bb-lb__meta">' +
						'<p class="bb-lb__caption"></p>' +
						'<div class="bb-lb__actions">' +
							'<a class="bb-lb__insta" target="_blank" rel="noopener">' + IG_SVG + '<span>View on Instagram</span></a>' +
							'<a class="bb-lb__shop">Shop this</a>' +
						'</div>' +
					'</div>' +
				'</div>';
			document.body.appendChild(el);

			el.addEventListener('click', function (e) {
				if (e.target.closest('[data-lb-close]')) { close(); return; }
				var stepper = e.target.closest('[data-lb-step]');
				if (stepper) step(parseInt(stepper.getAttribute('data-lb-step'), 10) || 0);
			});

			document.addEventListener('keydown', function (e) {
				if (!isOpen()) return;
				if (e.key === 'Escape') close();
				else if (e.key === 'ArrowRight') step(1);
				else if (e.key === 'ArrowLeft') step(-1);
				else if (e.key === 'Tab') trapTab(e);
			});

			// swipe left / right on the video to change reel (phones have no room for side arrows)
			var x0 = null;
			var y0 = null;
			el.addEventListener('touchstart', function (e) {
				if (!e.target.closest('.bb-lb__frame')) { x0 = null; return; }
				x0 = e.touches[0].clientX;
				y0 = e.touches[0].clientY;
			}, { passive: true });
			el.addEventListener('touchend', function (e) {
				if (x0 === null) return;
				var dx = e.changedTouches[0].clientX - x0;
				var dy = e.changedTouches[0].clientY - y0;
				x0 = null;
				if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) step(dx < 0 ? 1 : -1);
			}, { passive: true });
		}

		function open(list, i) {
			build();
			group = list;
			index = i;
			lastFocus = document.activeElement;
			pauseCards();
			el.hidden = false;
			document.documentElement.classList.add('bb-lb-open');
			render();
			el.querySelector('.bb-lb__close').focus();
		}

		function step(by) {
			if (!by || group.length < 2) return;
			index = (index + by + group.length) % group.length;
			render();
		}

		function close() {
			if (!isOpen()) return;
			teardown();
			el.hidden = true;
			document.documentElement.classList.remove('bb-lb-open');
			if (lastFocus && lastFocus.focus) lastFocus.focus();
			lastFocus = null;
			resumeVisibleCards();
		}

		return { open: open, close: close, isOpen: isOpen };
	})();

	function initRail(rail) {
		// shopify:section:load re-runs init for the whole page; skip rails already wired
		if (rail.getAttribute('data-bb-reels-ready') === '1') return;
		rail.setAttribute('data-bb-reels-ready', '1');

		var cards = Array.prototype.slice.call(rail.querySelectorAll('[data-bb-reel]'));
		cards.forEach(function (card, i) {
			var opener = card.querySelector('.bb-reel__open');
			if (!opener) return;
			opener.addEventListener('click', function (e) {
				// cmd / ctrl-click still opens the product in a new tab
				if (e.metaKey || e.ctrlKey || e.shiftKey || (e.button && e.button !== 0)) return;
				e.preventDefault();
				player.open(cards, i);
			});
		});

		var videos = Array.prototype.slice.call(rail.querySelectorAll('.bb-reel__video'))
			.filter(function (v) { return v.tagName === 'VIDEO'; });
		if (!videos.length) return;

		if (reduceMotion || !('IntersectionObserver' in window)) {
			// no motion: show the first frame instead of an empty card
			videos.forEach(function (v) { v.preload = 'metadata'; });
			return;
		}

		var io = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				var rec = entry.target.bbReel;
				if (rec) rec.visible = entry.isIntersecting;
				if (entry.isIntersecting && !player.isOpen()) quietPlay(entry.target);
				else entry.target.pause();
			});
		}, { threshold: 0.2 });

		videos.forEach(function (v) {
			var rec = { el: v, visible: false };
			v.bbReel = rec;
			cardVideos.push(rec);
			io.observe(v);
		});
	}

	function init(scope) {
		(scope || document).querySelectorAll('.js-bb-reels').forEach(initRail);
	}

	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
	else init();

	document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
